import { collection, query, where, getDocs, doc, getDoc, addDoc, updateDoc, arrayUnion, increment } from 'firebase/firestore'

import { db } from "../firebase";
import axios from "axios";
import {getMapForRide} from "../apis/mapAPI";

const osmAddressApiBaseUrl = "https://nominatim.openstreetmap.org/search?q=";
const osmAddressApiEndUrl = "&format=geocodejson";

export async function addNewRide(driverId, testId, driverLocation, vacantSeats, driverCity, driverEmail) {
    const address =  await getCoordinatesFromAddress(driverLocation);
    const x = address[1];
    const y = address[0];
    const docRef = await addDoc(collection(db, "geo-rides"), {
        driver_location: driverLocation,
        driver_user_id: driverId,
        num_available_seats: vacantSeats,
        test_id: testId,
        coordinate_x: x,
        coordinate_y: y,
        driver_city: driverCity,
        driver_email: driverEmail,
        riders_id: [],
        riders_locations: [],
        ride_map_html: ""
    });
    console.log("Document written with ID: ", docRef.id);
    const mapHtml = await getMapForRide(docRef.id);
    await updateDoc(docRef, {
        ride_map_html: mapHtml
    });
    return docRef.id;
}

export async function joinExistingRide(rideId, userIdToJoin, userPickupLocation, userFullName, userPhoneNumber, userAddress) {
    const rideDocRef = doc(db, 'geo-rides', rideId);
    const pickupCoordinatesReverse = await getCoordinatesFromAddress(userPickupLocation);
    const pickupCoordinates = {x: pickupCoordinatesReverse[1], y: pickupCoordinatesReverse[0] };
    const riders_data = { phone_number: userPhoneNumber, full_name: userFullName, address: userAddress }
    await updateDoc(rideDocRef, {
       riders_id: arrayUnion(userIdToJoin),
       riders_locations: arrayUnion(pickupCoordinates),
       num_available_seats: increment(-1),
       riders_data: arrayUnion(riders_data)
    });
    console.log(`Successfully added passenger ${userIdToJoin} to ride ${rideId}`);
    const newMapHtml = await getMapForRide(rideId);
    await updateDoc(rideDocRef, {
        ride_map_html: newMapHtml
    });
}

export async function getCoordinatesFromAddress(address) {
    const requestUrl = osmAddressApiBaseUrl.concat(address).concat(osmAddressApiEndUrl)
    console.log(`Fetching coordinates for address ${address}...`)
    const resData = await axios.get(requestUrl).then(res => res.data.features[0])
    const coordinates = resData.geometry.coordinates;
    console.log(`received coordinates: ${coordinates}`);
    return coordinates;
}

export async function getAllTests() {
    console.log(`Fetching tests from DB...`)
    const testDocs = await getDocs(collection(db, "tests"));
    console.log(`got ${testDocs.size} tests from DB`)

    return testDocs.docs;
}

export async function getExistingRides(currentUser) {
    const ridesRef = collection(db, "geo-rides")
    const rides = await getDocs(query(ridesRef, where("driver_user_id", "==", currentUser.uid))) 
    let result = [] 
    for (const ride of rides.docs) {
    const rideData = ride.data()
    const test = await getDoc(doc(db, "tests", rideData.test_id))
    result.push({
        time: test.data().date_time,
        name: test.data().course_name,
        id: ride.id
    })
    }
    return result
}

export async function getRideForPassenger(id) {
    const ride = await getDoc(doc(db,"geo-rides", id)) 
    const rideData = ride.data()
    const driver = await getDoc(doc(db, "user_details", rideData.driver_email))
    const test = await getDoc(doc(db, "tests", rideData.test_id))
    const driverData = driver.data()

    const result = {
        driver_name: driverData.first_name + " " + driverData.last_name,
        driver_phone: driverData.phone_number,
        map: rideData.ride_map_html,
        time: test.data().date_time.toDate().toLocaleString(),
        course_name: test.data().course_name
    }
    return result
}

export async function getRideForDriver(id) {
    const ride = await getDoc(doc(db,"geo-rides", id)) 
    const rideData = ride.data()
    const test = await getDoc(doc(db, "tests", rideData.test_id))

    const result = {
        map: rideData.ride_map_html,
        time: test.data().date_time.toDate().toLocaleString(),
        course_name: test.data().course_name,
        riders_data: rideData.riders_data
    }
    return result
}

export async function getRidesAsPassenger(currentUser) {
    const ridesRef = collection(db, "geo-rides")
    const rides = await getDocs(query(ridesRef, where("riders_id", "array-contains", currentUser.uid))) 
    let result = [] 
    for (const ride of rides.docs) {
        const rideData = ride.data()
        const test = await getDoc(doc(db, "tests", rideData.test_id))
        result.push({
            time: test.data().date_time,
            name: test.data().course_name,
            id: ride.id
        })
    }
    return result
}

export async function getAvailableRidesByCity(city) {
    console.log(`Fetching available rides from city ${city}...`)
    const ridesRef = collection(db, "geo-rides")
    const availableRides = await getDocs(
        query(ridesRef, where("driver_city", "==", city) , where("num_available_seats", ">", 0))
    );
    console.log(`received ${availableRides.size} available rides`)
    let result = [];
    for (const ride of availableRides.docs) {
        const rideData = ride.data();
        const test = await getDoc(doc(db, "tests", rideData.test_id));
        const driver = await getDoc(doc(db, "user_details", rideData.driver_email));
        result.push({
            time: test.data().date_time,
            course_name: test.data().course_name,
            test_id: test.id,
            id: ride.id,
            available_seats: rideData.num_available_seats,
            driver_first_name: driver.data().first_name,
            driver_last_name: driver.data().last_name
        })
    }
    return result;
}